export const MOTORSHOW_MODULE = {
    1: '新车预告',
    2: '同镇站长',
    3: '图文快讯',
    4: '新车实拍',
    5: '车界盛典',
    6: '车展热聊',
    7: '品牌专访',
    8: '好车推荐',
    9: '趣味角',
    10: '现场直播'
}
